import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

type StyleProps = {
	isMobileVersion: boolean;
};

export const useStyles = makeStyles(theme => {
	return {
		layerContainer: {
			width: '100%',
			justifyContent: 'left',
			display: 'flex',
			overflow: 'auto'
		},
		imageContainer: {
			width: (props: StyleProps) => (props.isMobileVersion ? '100%' : '50%'),
			padding: (props: StyleProps) => (props.isMobileVersion ? 0 : 50),
			height: '100%',
			display: 'flex'
		},
		detailContainer: {
			width: (props: StyleProps) => (props.isMobileVersion ? '100%' : '50%'),
			height: '100%',
			padding: (props: StyleProps) => (props.isMobileVersion ? 20 : 50),
			justifyContent: 'left'
		},
		mediaLabel: {
			overflowWrap: 'break-word',
			width: '100%',
			marginTop: 0
		},
		fieldContainer: {
			paddingBottom: 5
		},
		fieldValue: {
			fontWeight: 'bold'
		},
		imageItemImg: {
			maxHeight: '100%',
			maxWidth: '100%',
			alignContent: 'start',
			objectFit: 'contain',
			WebkitUserSelect: 'none',
			MozUserSelect: 'none',
			userSelect: 'none',
			WebkitTouchCallout: 'none'
		},
		loading: {
			marginTop: 10
		},
		globalDescription: {
			whiteSpace: 'pre-line'
		}
	};
});
